<div class="container-lg container-xl  bg-white   cornerr" *ngIf="id=='organigrama'">
<div class="container" >
<div class="header-title-section">
    <img src="https://nld.gob.mx/assets/logos/logonld.png" class="logo" />
    <h1>Dependencias Municipales</h1>
</div>
  

    <div class="organigrama">
        <div *ngFor="let secretaria of secretarias" class="secretaria" [class.collapsed]="secretaria.collapsed"
            [class.hidden]="secretaria.hidden">
    
            <div class="secretaria-header" (click)="toggleSecretaria(secretaria)">
                <div class="title-section">
                    <span class="secretaria-title">{{ secretaria.nombre }}</span>
                    <span class="secretaria-titular" *ngIf="secretaria.titular">{{ secretaria.titular }}</span>
                  
                </div>
              <!--  <span class="arrow">▼</span>-->
            </div>
          
            <div class="direcciones">
              
                <div *ngFor="let direccion of secretaria.direcciones" class="direccion"
                    [class.highlight]="highlightDireccion(direccion)">
                    <div class="direccion-text">{{ direccion }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>

<div class="container-lg container-xl px-4  bg-white my-5 py-5 cornerr" *ngIf="id=='convocatoria1'">
    <div class="row">
        <div class="col-2"></div>
        <div class="col-8">
            <img src="https://nld.gob.mx/assets/img/convocatoria11.jpg" class="rounded w-100" />
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="tramites-comunes-footer">
                <a href="https://becas2026.nld.gob.mx" target="_blank" class="btn-ver-mas-tramites">
                    <span>INGRESA AQUÍ BECA JUNTOS POR EL DESARROLLO CULTURAL 2026</span>
                    <i class="bi bi-arrow-right-circle"></i>
                </a>
            </div>
        </div>
    </div>
</div>

<div class="container-lg container-xl px-4  bg-white my-5 py-5 cornerr" *ngIf="id=='calidad'">

    <div class="row" style="padding-left: 30px;">
        <div class="row">
            <div class="col-md-12">

                <div class="box-btn my-4">
                    <p><strong style="text-decoration: none;color:#8B6F50;font-size: 16px;cursor: pointer;">
                        Direccion de Calidad y Evaluacion de Procesos
                        </strong></p>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-xs-12 text-start init">
                <div class="view-content">
                    <div>

                        <ul>

                            <li>
                                <div class="views-field views-field-title"><span class="field-content">
                                        <a target="_new"
                                            href="https://nld.gob.mx/assets/documentos/manualGestionAmbiental.pdf"
                                            style="cursor: pointer;margin-left: 18px;display: inline-block;text-decoration: none;outline: 0 none;color: #3D4543;font-weight: bold;font-weight: 500;">
                                            Manual del Sistema de Gestión Ambiental</a>
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="views-field views-field-title"><span class="field-content">
                                        <a target="_new"
                                            href="https://nld.gob.mx/assets/documentos/manualCalidad.pdf"
                                            style="cursor: pointer;margin-left: 18px;display: inline-block;text-decoration: none;outline: 0 none;color: #3D4543;font-weight: bold;font-weight: 500;">
                                            Manual de Calidad</a>
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="views-field views-field-title"><span class="field-content">
                                        <a target="_new"
                                            href="https://nld.gob.mx/assets/documentos/politicaAmbiental.pdf"
                                            style="cursor: pointer;margin-left: 18px;display: inline-block;text-decoration: none;outline: 0 none;color: #3D4543;font-weight: bold;font-weight: 500;">
                                            Politica Ambiental</a>
                                    </span>
                                </div>
                            </li>

                            <li>
                                <div class="views-field views-field-title"><span class="field-content">
                                        <a target="_new" href="https://nld.gob.mx/assets/documentos/politicaCalidad.pdf"
                                            style="cursor: pointer;margin-left: 18px;display: inline-block;text-decoration: none;outline: 0 none;color: #3D4543;font-weight: bold;font-weight: 500;">
                                            Politica de Calidad</a>
                                    </span>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>






            </div>

        </div>

    </div>

</div>

<div class="container-lg container-xl px-4  bg-white my-5 py-5 cornerr" *ngIf="id=='capacitacion'">
    <div class="row" style="padding-left: 30px;">
        <div class="row">
            <div class="col-md-12">

                <div class="box-btn my-4">
                    <p><strong style="text-decoration: none;color:#8B6F50;font-size: 16px;cursor: pointer;">
                        NLD Capacitación y Profesionalización 4.0
                        </strong></p>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-xs-12 text-start init">
                <div class="view-content">
                    <div>

                        <ul>

                            <li>
                                <div class="views-field views-field-title"><span class="field-content">
                                        <a target="_new"
                                            href="https://nld.gob.mx/assets/documentos/indicadoresCapacitacion.pdf"
                                            style="cursor: pointer;margin-left: 18px;display: inline-block;outline: 0 none;color: #3D4543;font-weight: bold;font-weight: 500;">
                                           Indicadores de Desempeño</a>
                                    </span>
                                </div>

                            </li>


                        </ul>


                    </div>
                </div>






            </div>

        </div>
        <div class="row">
            <div class="col-md-12">

                <table class="table">
                    <thead>
                        <tr>
                            <th>Numero de Servidores publicos municipales capacitados en el año evaluado</th>
                            <th>Total de servidores publicos municipales</th>
                            <th>Resultado</th>
                            <th>Total en %</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{indicator.numero_servidores_capacitados}}</td>
                            <td>{{indicator.total_servidores_publicos}}</td>
                            <td>{{indicator.resultado}}</td>
                            <td>{{indicator.total_en_porcentaje}}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="col-md-12" align="right">
                <a target="_new" href="https://nld.gob.mx/assets/documentos/indicadoresCapacitacion.pdf" style="cursor: pointer;margin-left: 18px;display: inline-block;outline: 0 none;color: #3D4543;font-weight: bold;font-weight: 500;">
                    Abrir Documento</a>
            </div>
        </div>

    </div>

</div>
<div class="container-lg container-xl px-4  bg-white my-5 py-5 cornerr" *ngIf="id=='politica'">
    <h1 style='margin-top:4.6pt;margin-right:0cm;margin-bottom:0cm;margin-left:7.2pt;font-size:16px;font-family:"Arial",sans-serif;'>
        POL&Iacute;TICA&nbsp;DE&nbsp;PRIVACIDAD</h1>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:.05pt;'><strong><span
                style='font-size:14px;font-family:"Arial",sans-serif;'>&nbsp;</span></strong></p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:0cm;margin-right:11.45pt;margin-bottom:.0001pt;margin-left:7.2pt;'>
        El&nbsp;presente&nbsp;Pol&iacute;tica&nbsp;de&nbsp;Privacidad&nbsp;establece&nbsp;los&nbsp;t&eacute;rminos&nbsp;que&nbsp;la&nbsp;aplicaci&oacute;n&nbsp;Yo&nbsp;NLD del Gobierno de Nuevo Laredo asegura y protege la informaci&oacute;n que es&nbsp;proporcionada
        por sus usuarios al momento de utilizar su aplicaci&oacute;n. El Gobierno&nbsp;de Nuevo Laredo est&aacute; comprometido con la seguridad de los datos de sus&nbsp;usuarios. Cuando le pedimos llenar los campos de informaci&oacute;n personal con
        la&nbsp;cual usted pueda ser identificado, lo hacemos asegurando que s&oacute;lo se emplear&aacute;&nbsp;de acuerdo con los t&eacute;rminos de este documento. Sin embargo, esta Pol&iacute;tica de&nbsp;Privacidad puede cambiar con el tiempo o ser
        actualizada por lo que le&nbsp;recomendamos&nbsp;y&nbsp;enfatizamos&nbsp;revisar&nbsp;continuamente&nbsp;esta&nbsp;p&aacute;gina&nbsp;para&nbsp;asegurarse&nbsp;que&nbsp;est&aacute;&nbsp;de&nbsp;acuerdo&nbsp;con dichos cambios.</p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:.3pt;'>&nbsp;</p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:0cm;margin-right:16.2pt;margin-bottom:.0001pt;margin-left:7.2pt;line-height:98%;'>
        La aplicaci&oacute;n del Gobierno de Nuevo Laredo es informativa y busca dar a&nbsp;conocer&nbsp;los&nbsp;servicios&nbsp;que&nbsp;brinda&nbsp;a&nbsp;trav&eacute;s&nbsp;de&nbsp;la&nbsp;aplicaci&oacute;n&nbsp;as&iacute;&nbsp;como&nbsp;las&nbsp;noticias&nbsp;mas&nbsp;recientes
        hechas&nbsp;por&nbsp;el&nbsp;gobierno&nbsp;de&nbsp;nuevo laredo.</p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:.55pt;margin-right:32.2pt;margin-bottom:.0001pt;margin-left:7.2pt;line-height:98%;'>
        Entre los servicios que se busca proporcionar es el pago del impuesto predial,&nbsp;solicitud&nbsp;de quejas, eventos&nbsp;entre otros servicios.</p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:.4pt;'><span style="font-size:13px;">&nbsp;</span></p>
    <h1 style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:7.2pt;font-size:16px;font-family:"Arial",sans-serif;'>
        Informaci&oacute;n&nbsp;que&nbsp;es&nbsp;recogida</h1>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:.4pt;'><strong><span
                style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></strong></p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:0cm;margin-right:6.2pt;margin-bottom:.0001pt;margin-left:7.2pt;'>
        Nuestra aplicaci&oacute;n Yo NLD podr&aacute; recoger informaci&oacute;n personal por ejemplo:&nbsp;Nombre, informaci&oacute;n de contacto como su direcci&oacute;n de correo electr&oacute;nico, tel&eacute;fono&nbsp;e informaci&oacute;n demogr&aacute;fica.
        As&iacute; mismo cuando sea necesario podr&aacute; ser requerida&nbsp;informaci&oacute;n espec&iacute;fica para procesar alg&uacute;n servicio como el pago del impuesto&nbsp;predial, infracciones de transito entre otros servicios.</p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:.4pt;'><span style="font-size:13px;">&nbsp;</span></p>
    <h1 style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:7.2pt;font-size:16px;font-family:"Arial",sans-serif;'>
        Uso&nbsp;de&nbsp;la&nbsp;informaci&oacute;n&nbsp;recogida</h1>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:.1pt;'><strong><span
                style='font-size:14px;font-family:"Arial",sans-serif;'>&nbsp;</span></strong></p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:0cm;margin-right:16.2pt;margin-bottom:.0001pt;margin-left:7.2pt;'>
        La Finalidad&nbsp;es&nbsp;que&nbsp;en&nbsp;base&nbsp;a&nbsp;la&nbsp;informaci&oacute;n&nbsp;obtenida&nbsp;podamos&nbsp;enviar&nbsp;alertas&nbsp;seg&uacute;n su ubicaci&oacute;n demogr&aacute;fica y poder atender con mas eficacia las&nbsp;necesidades&nbsp;que
        presenten&nbsp;los usuarios.</p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;'><span style="font-size:17px;">&nbsp;</span></p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:8.2pt;margin-right:0cm;margin-bottom:.0001pt;margin-left:7.2pt;'>
        Gobierno de Nuevo Laredo est&aacute; altamente comprometido para cumplir con el&nbsp;compromiso de mantener su informaci&oacute;n segura. Usamos los sistemas m&aacute;s&nbsp;avanzados&nbsp;y&nbsp;los&nbsp;actualizamos&nbsp;constantemente&nbsp;para&nbsp;asegurarnos&nbsp;que&nbsp;no&nbsp;exista&nbsp;ning&uacute;n&nbsp;acceso&nbsp;no&nbsp;autorizado.
    </p>
    <p><span style='font-size:15px;font-family:"Arial MT",sans-serif;'><br>&nbsp;</span></p>
    <p style='margin:0cm;font-size:16px;font-family:"Arial MT",sans-serif;margin-top:3.95pt;margin-right:16.2pt;margin-bottom:.0001pt;margin-left:7.2pt;line-height:98%;'>
        Se reserva el derecho de cambiar los t&eacute;rminos de la presente Pol&iacute;tica de Privacidad en cualquier momento.
    </p>
</div>
<div class="container cornerr" *ngIf="id=='turismo'">
    <div class="row">
        <div class="col-3"></div>
        <div class="col-6">
            <div class="post">
                <div class="post-top">
                    <div class="dp">
                        <img src="https://scontent.fntr6-1.fna.fbcdn.net/v/t39.30808-6/302273536_440699774759884_1238049875917475285_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeHJPxv04mXQGgE4d0h1tY2w3JgZJb7OAmjcmBklvs4CaAzpd5XTEtcNLwt1R9VcqtWpsxQosZ4m07Bz-_9SIqMA&_nc_ohc=3drUGeJYU_sAX98Mwcj&_nc_ht=scontent.fntr6-1.fna&oh=00_AT_KuYDTICxhLZ2k4MJEXpyl_9K4Z-n7Mceh694AQv_r1g&oe=631A4455"
                            alt="">
                    </div>
                    <div class="post-info">
                        <p class="name" style="margin-bottom: 0px;font-weight: bold; font-size:medium;">Dirección de Turismo Nuevo Laredo</p>

                    </div>
                    <i class="fas fa-ellipsis-h"></i>
                </div>
                <div class="post-content">
                    No te olvides, el 08 de septiembre es jueves de Activarnos con Ritmos Latinos en el Centro Histórico
                    <img src="https://scontent.fntr6-1.fna.fbcdn.net/v/t39.30808-6/302273536_440699774759884_1238049875917475285_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeHJPxv04mXQGgE4d0h1tY2w3JgZJb7OAmjcmBklvs4CaAzpd5XTEtcNLwt1R9VcqtWpsxQosZ4m07Bz-_9SIqMA&_nc_ohc=3drUGeJYU_sAX98Mwcj&_nc_ht=scontent.fntr6-1.fna&oh=00_AT_KuYDTICxhLZ2k4MJEXpyl_9K4Z-n7Mceh694AQv_r1g&oe=631A4455">
                </div>
                <div class="post-bottom">
                    <div class="action">
                        <i style="color:#8B6F50;" class="far fa-thumbs-up"></i>
                        <span style="color:#8B6F50;">Like</span>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-3"></div>
    </div>

</div>

<div class="container cornerr" *ngIf="id=='docente'">
    <div class="row">
        <div class="container">
            <br>
            <br>
            <br>
        
            <br>
            <br>
        
            <br>
            <div class="row">
                <div class="col-12 col-md-12">
                    <div class="row mb-4">
                        <div class="col-md-12 ml-auto mr-auto text-center">
                            <h2 class="title mt-2">PROGRAMA DE APOYO AL TRABAJO DOCENTE 2026
                            </h2>
                           <h4>Consulta de resultados</h4>
        
                        </div>
                    </div>
                    <br>
                   
                    <div class="card-body">
        
                        <div class="row">
        
                       
                        </div>
        
                        <br>
        
        
                      
        
        
        
                        <div class="row">
                            <div class="col-md-3"></div>
                            <div class="col-md-6">
                                <h5 class="colorSecundario" style="margin-bottom:0;padding-bottom:0px">Escribe tu Numero de
                                    Folio</h5>
                                <p style="font-size:14px;margin-top:0;padding-top:0px">Incluir todos los digitos del Folio.</p>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="input-group input-group-alternative">
                                            <div class="input-group-prepend"><span class="input-group-text"><i
                                                        class="bi ">   </i>    AM-</span></div>
                                            <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;"
                                                type="number" [(ngModel)]="folio" name="folio" (keydown)="onKeydownEvent()"
                                                aria-label="Escribe tu número de folio" class="form-control"
                                                placeholder="Escribe tu folio..."  required>
                                        </div>
                                    </div>
                                  
                                </div>
        
                            </div>
                            <div class="col-md-3"></div>
        
                        </div>
        
                        <div class="row mt-5">
                            <div class="col-md-12" align="center">
        
                                <div class="form-group">
                                    <!--   <ngx-recaptcha2 *ngIf="!norobot" ngModel name="captcha" [siteKey]="siteKey" (success)="handleSuccess($event)" [useGlobalDomain]="false"
                                                        [hl]="lang" (expire)="handleExpire($event)">
                                                    </ngx-recaptcha2>
                                                -->
                                    <button *ngIf="tipo!='0'" class="btn btn-primary pull-right" type="button"
                                        (click)="enviarFolio2()"> <span> <i class="bi bi-search"></i> Buscar</span>
                                    </button>
                                </div>
        
                            </div>
                        </div>
                        <br>
                        <br>
                        <br>
        
                        <div *ngIf="bandera" class="row align-items-center justify-content-center text-center"
                            style="background-color: #ffffff;">
                         
        
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div style="font-size:1.5em;" class="form-group">
                                    <h3 style="color: #BB955E" *ngIf="estado!=''">Estatus</h3>
                                    <h5 class="font-weight-bold">
                                        <span>
                                        </span> {{estado}}
                                    </h5>
                                    <p>{{motivo}}</p>
                                </div>
                            </div>
                          
                        </div>
                        <br>
               
                    <div class="row">
                        <div class="col-md-12 mt-5">
                            <small id="emailHelp" class="form-text text-muted"
                                style="font-weight: 300;text-transform: uppercase;">
                             <!--   <strong>Cualquier duda o aclaración marcar al departamento de becas: (867) 711 35 05 - Ext.
                                    3409</strong>-->
                                </small>
        
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">  </div>
    </div>

</div>
</div>
<div class="container-lg container-xl px-4  bg-white my-5 py-5 cornerr" *ngIf="id=='consulta'">
<div class="container">
    
   
    <div class="row">
        <div class="col-12 col-md-12">
            <div class="row mb-4">
                <div class="col-md-12 ml-auto mr-auto text-center">
                    <h1 class="title mt-2">GUÍAS DIDÁCTICAS 2025</h1>
                   <!-- <h5>BECA JUNTOS POR LA EDUCACIÓN PRIMARIA 2025</h5>-->

                </div>
            </div>
            <br>
         
            <div class="card-body">

                <div class="row">

                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <h5 class="colorSecundario" style="margin-bottom:0;padding-bottom:0px">Ingrese la Clave de Centro de Trabajo</h5>
                   <!-- <p style="font-size:14px;margin-top:0;padding-top:0px">Incluir todos los digitos del Folio.</p>-->
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="input-group input-group-alternative">
                                <div class="input-group-prepend"><span class="input-group-text"><i class="bi bi-search"></i></span>
                                </div>
                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text"
                                    [(ngModel)]="folio" name="folio" (keydown)="onKeydownEvent()"
                                    aria-label="Escribe tu Clave" class="form-control" placeholder="Escribe Clave..."
                                    type="text" required>
                            </div>
                        </div>
                        <!-- <div *ngIf="folio.errors?.pattern" class="alert alert-danger" role="alert">
                                                                                Folio no valido, verifique que este tecleado correctamente. Recuerde que el folio inicia con la
                                                                                letra B
                                                                            </div>-->
                    </div>
                
                </div>
                <div class="col-md-3"></div>

                </div>

                <br>


              
             
                <div class="row mt-5">
                    <div class="col-md-12" align="center">

                        <div class="form-group">
                            <!--   <ngx-recaptcha2 *ngIf="!norobot" ngModel name="captcha" [siteKey]="siteKey" (success)="handleSuccess($event)" [useGlobalDomain]="false"
                                        [hl]="lang" (expire)="handleExpire($event)">
                                    </ngx-recaptcha2>
                                -->
                            <button *ngIf="tipo!='0'" class="btn btn-primary pull-right" type="button"
                                (click)="enviarFolio()"> <span> <i class="bi bi-search"></i> Buscar</span>
                            </button>
                        </div>

                    </div>
                </div>
                <br>
                <br>
                <br>

                <div *ngIf="bandera" class="row align-items-center justify-content-center text-center"
                    style="background-color: #ffffff;">
                 <!--
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="estado!=''">
                        <div style="font-size:1.5em;" class="form-group">
                            <h3 style="color: #BB955E;">Folio</h3>
                            <h5 class="font-weight-bold">{{folio}}</h5>
                        </div>

                    </div>-->

                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="bandera">
                        <div style="font-size:1.5em;" class="form-group">
                           


                            <div  *ngIf="bandera">
                                <h5>Una vez que haya realizado el llenado de los formatos Ficha de Solicitud</h5>
                                <h5>de Guías Didácticas 2025 y Relación de Alumnos(as) solicitantes de</h5>
                                <h5>Guías Didácticas 2025, deberá enviarlos en formato editable Excel a la</h5>
                                <h5>Dirección de Educación al correo electrónico: </h5>
                                <h5 style="color: rgb(55, 55, 248);">guiasescolares2025@gmail.com</h5>
                                <br>
                               
                                <a href="https://nld.gob.mx/assets/documentos/instrucciones.docx" target="_blank">Instrucciones de llenado</a>
                                <br>
                                <br>
                                <br>
                               
                               
                                <br>
                                <div *ngIf="prescolar">
                                    <a href="https://nld.gob.mx/assets/documentos/relPre.xlsx" target="_blank" style="color: rgb(144, 154, 0);">Relación de Alumnos(as) solicitantes de Guías Didácticas 2025 PREESCOLAR</a>
                                    <br><br><a href="https://nld.gob.mx/assets/documentos/fichaPre.xlsx" target="_blank" style="color: rgb(144, 154, 0);">Ficha de Solicitud de Guías Didácticas 2025 PREESCOLAR</a>
                                </div>
                                <div *ngIf="primaria">
                                    <a href="https://nld.gob.mx/assets/documentos/relPrim.xlsx" target="_blank" style="color: rgb(144, 154, 0);">Relación de Alumnos(as) solicitantes de Guías Didácticas 2025 PRIMARIA</a>
                                   <br><br> <a href="https://nld.gob.mx/assets/documentos/fichaPrim.xlsx" target="_blank" style="color: rgb(144, 154, 0);">Ficha de Solicitud de Guías Didácticas 2025 PRIMARIA</a>
                                
                                </div>
                                <div *ngIf="secundaria">
                                    <a href="https://nld.gob.mx/assets/documentos/relSec.xlsx" target="_blank" style="color: rgb(144, 154, 0);">Relación de Alumnos(as) solicitantes de Guías Didácticas 2025 SECUNDARIA</a>
                                    <br><br><a href="https://nld.gob.mx/assets/documentos/fichaSec.xlsx" target="_blank" style="color: rgb(144, 154, 0);">Ficha de Solicitud de Guías Didácticas 2025 SECUNDARIA</a>
                                    </div>


                                    <br>
                                    <br>
                                    <p>Favor de llenar el registro, todos los campos son obligatorios.</p>
                            </div>
                            
                            
                            
                           <!-- <h3 style="color: #BB955E"></h3>
                            <h5 class="font-weight-bold">
                                <span>
                                </span> {{this.estado}}
                            </h5>
                            <p>{{motivo}}</p>-->
                        </div>
                    </div>
                    <!--  <div class="row" *ngIf="escuela!=''">
                                    <div class="col-md-12">
                                        <strong>REFERENCIA:</strong><p>
                                            {{escuela}}
                                        </p>
                                    </div>
                                </div>-->
                </div>
                <br>
                <br>
                <br>

            </div>
            <!--
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-center">
                            <h2>{{total}}</h2>
                        </div>
                    </div>
                </div>-->
            <div class="row">
                <div class="col-md-12 mt-5">
                    <small id="emailHelp" class="form-text text-muted"
                        style="font-weight: 300;text-transform: uppercase;">
                        <strong>Cualquier duda o aclaración marcar al numero: (867) 711 35 05 - Ext.
                            3409</strong></small>

                </div>
            </div>
        </div>
    </div>
</div>
</div>
<div class="container" *ngIf="id=='gabinete2'">
    <div class="row my-5">
        <div class="col-12">
            <img src="https://nld.gob.mx/assets/gabinete.JPG" class="img-fluid rounded" alt="Responsive image">
        </div>
    </div>
    <h1 class="titulo-principal">Secretarías</h1>
    <div class="row">
       
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title">Lic. Rolando Martín Guevara González</h5>
                    <p class="card-text">Jefe de la Oficina de la Presidenta</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title">Lic. Juan Ángel Martínez Salazar</h5>
                    <p class="card-text">Secretarío del Ayuntamiento</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title">C.P. Enrique Álvarez del Castillo Rojas</h5>
                    <p class="card-text">Secretarío de Tesorería y Finanzas</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
       
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title">Lic. Ma. Reynalda Perales Rodríguez</h5>
                    <p class="card-text">Secretaría de Contraloría y Transparencia</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title">Dra. Liliana Margarita Arjona Barocio</h5>
                    <p class="card-text">Secretaría de Bienestar Social</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title">Lic. Marla Isabel Montantes González</h5>
                    <p class="card-text">Secretaría de Administración</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
    
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title">Arq. Carlos Germán de Anda Hernández</h5>
                    <p class="card-text">Secretarío de Obras Públicas y Desarrollo Urbano</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title  mt-3">Lic. Ernesto Ferrara Theriot</h5>
                    <p class="card-text mb-3">Secretarío de Educación, Cultura y Deporte</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title mt-3">Ing. Even Arredondo Bravo</h5>
                    <p class="card-text mb-3">Secretarío de Servicios Públicos Primarios</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
    
    </div>
    <div class="row">
      
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title">Arq. Lorena Guadalupe Cavazos Muñoz</h5>
                    <p class="card-text">Secretaría de Desarrollo Económico</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
        <div class="col-4">
           
        </div>
    
    </div>
    <div class="row">
        <div class="col-12">
            <h1 class="titulo-principal">Coordinaciones Generales</h1>
        </div>
    </div>
   
    <div class="row">
        <div class="col-2">
            
        </div>
        <div class="col-12">
            <div class="card card-profile">
                <!--  <img src="https://via.placeholder.com/400x250" class="card-img-top" alt="Foto de perfil">-->
                <div class="card-body">
                    <h5 class="card-title">Lic. Tania Taboada Blanco</h5>
                    <p class="card-text">Coordinadora General de Gestión Ambiental</p>
                    <!-- <a href="" class="btn btn-primary">Contactar</a>-->
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="card card-profile">
            <div class="card-body">
                <h5 class="card-title">Mttra. Imelda Mangín Torre</h5>
                <p class="card-text">Coordinadora General de Institutos</p>
                <!-- <a href="" class="btn btn-primary">Contactar</a>-->
            </div>
            </div>
        </div>
    
    </div>
</div>
<div class="container" *ngIf="id=='tramites'">
    <div class="row">
        <div class="col-12">
            <div class="container-lg container-xl px-4  bg-white my-5 py-5 cornerr">
            
                <div class="row tramites-home">
                    <div class="tramites-home col-12 col-xs-12 col-md-6 col-sm-6 col-lg-6 mt-2">
            
                        <div class="views-element-container block block-views block-views-blocklistado-tramites-y-servicios-block-1"
                            id="block-views-block-listado-tramites-y-servicios-block-1-2">
            
                            <h2 class="block-title colorSecundario">Trámites más buscados</h2>
            
                            <div>
                                <div
                                    class="view view-listado-tramites-y-servicios view-id-listado_tramites_y_servicios view-display-id-block_1 js-view-dom-id-ace45a4a7438a4b66a3d0ac2a4f4423379825705f2c36e351724c73b10fa8255">
            
            
            
                                    <div class="view-content">
                                        <div>
            
                                            <ul>
                                                <!-- <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a routerLink="/ciac" href="#"
                                                                hreflang="es">CIAC</a></span></div>
                                                </li>-->
            
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                routerLink="/predial" href="#" hreflang="es">Consulta y pago
                                                                predial</a>
                                                            <br>
                                                            <p style="color:grey">Teléfono pago predial: 711-35-75 / 711-35-02</p>
                                                            <p style="color:grey">Correo electrónico: predial@nld.gob.mx</p>
                                                        </span></div>
                                                </li>
                                                <!--
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                 href="http://cartanap.nld.gob.mx/"  target="_new" hreflang="es">Carta de No
                                                                Antecedentes</a></span></div>
                                                </li>-->
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                href="http://empleo.nld.gob.mx/home" target="_new"
                                                                hreflang="es">Bolsa de
                                                                Empleo</a></span></div>
                                                </li>
            
                                                <!--  <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                href="http://072.mx/nuevolaredo/" hreflang="es">Solicitud de CIGA</a></span></div>
                                                </li>
                                                -->
            
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                routerLink="/diga" href="#" hreflang="es">Quejas y Denuncias
                                                                a Funcionarios Públicos</a></span></div>
                                                </li>
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                href="https://www.comapanuevolaredo.gob.mx/"
                                                                hreflang="es">Comapa</a></span></div>
                                                </li>
                                                <!-- <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a href="https://nld.gob.mx/assets/documentos/CONVOCATORIA BECA NUEVA ERA.pdf"
                                                                hreflang="es" target="_new">Convocatoria Beca Nueva Era</a></span></div>
                                                </li>-->
                                                <!--  <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                href="http://072.mx/nuevolaredo/" 
                                                                target="_new">072</a></span></div>
                                                </li>
                                            -->
                                                <!--
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a routerLink="/becas" href="#"
                                                                hreflang="es">Consulta el estatus de tu Beca</a></span></div>
                                                </li>
                                            -->
            
                                            </ul>
            
                                        </div>
            
                                    </div>
            
                                </div>
                            </div>
            
                        </div>
            
                    </div>
                    <div class="tramites-home col-12 col-xs-12 col-md-6 col-sm-6 col-lg-6 mt-2">
            
                        <div class="views-element-container block block-views block-views-blocklistado-tramites-y-servicios-block-1"
                            id="block-views-block-listado-tramites-y-servicios-block-1-2">
            
                            <h2 class="block-title colorSecundario">Más Gobierno de Nuevo Laredo</h2>
            
                            <div>
                                <div
                                    class="view view-listado-tramites-y-servicios view-id-listado_tramites_y_servicios view-display-id-block_1 js-view-dom-id-ace45a4a7438a4b66a3d0ac2a4f4423379825705f2c36e351724c73b10fa8255">
            
            
            
                                    <div class="view-content">
                                        <div>
            
                                            <ul>
            
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                href="https://www.gob.mx/ActaNacimiento/" target="_new"
                                                                hreflang="es">Acta de
                                                                Nacimiento</a></span></div>
                                                </li>
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                href="https://www.gob.mx/curp/" target="_new"
                                                                hreflang="es">CURP</a></span>
                                                    </div>
                                                </li>
            
            
            
                                                <!--
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content">
                                                        <a href="https://copladem.nld.gob.mx/"
                                                                target="_new" hreflang="es">COPLADEM</a></span></div>
                                                </li>
                                            -->
            
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                href="http://201.144.104.26/nldretys/" hreflang="es">Trámites y
                                                                Servicios</a></span></div>
                                                </li>
            
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                routerLink="/resultados" href="#" hreflang="es">Resultados de
                                                                Servicios Públicos Municipales</a></span></div>
                                                </li>
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                href="https://dif.nld.gob.mx" hreflang="es">DIF Nuevo
                                                                Laredo</a></span></div>
                                                </li>
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a
                                                                href="https://copladem.nld.gob.mx/#/inicio"
                                                                hreflang="es">COPLADEM</a></span></div>
                                                </li>
            
                                                <!--
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content"><a target="_new" href="https://obraspublicas.nld.gob.mx/"
                                                            hreflang="es">Avance de Obras Públicas</a></span></div>
                                                </li>
                                            -->
            
                                            </ul>
            
                                        </div>
            
                                    </div>
            
                                </div>
                            </div>
            
                        </div>
            
                    </div>
            
            
                </div>
            
            
            </div>

        </div>
    </div>
    <div class="row mb-5">
        <div class="col-12">
            <div class="col-12 d-none d-md-block">
                <div class="d-flex justify-content-center">
                    <h3>
            
                        <a class="btn-prepa rounded" href="http://201.144.104.26/nldretys/"
                            style="text-decoration: none;color: white;">
                                Más Trámites y Servicios
            
                        </a>
                    </h3>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-lg container-xl px-4  bg-white my-5 py-5 cornerr" *ngIf="id=='directorio'">
   
<div class="directorio-container" *ngIf="id=='directorio'">
    <!-- Encabezado -->
    <div class="directorio-header">
        <img src="https://nld.gob.mx/assets/logos/logonld.png" class="directorio-logo" />
        <h1>Directorio Telefónico Municipal</h1>
    </div>

    <!-- Buscador -->
    <div class="directorio-search">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Buscar dependencia, cargo o extensión..." [(ngModel)]="searchTerm"
            (input)="filtrarDependencias()" class="search-input">
    </div>

    <!-- Contador de resultados -->
    <div class="search-results-count" *ngIf="searchTerm">
        <span>{{ dependenciasFiltradas.length }} resultados encontrados</span>
    </div>

    <!-- Lista de dependencias -->
    <div class="dependencias-list">
        <div class="dependencia-card" style="text-align: center;" >
            
            <div class="dependencia-header rounded" style="align-items: center;">
                
                <h2 style="color: white;">CONMUTADOR PRINCIPAL: 7 11 3500</h2>
            </div>
        </div>
        <div class="dependencia-card" [class.secretaria]="dep.nombre.includes('SECRETARÍA') || dep.nombre.includes('OFICINA DE LA PRESIDENTA')"
         *ngFor="let dep of dependenciasFiltradas; let i = index">
            <div class="dependencia-header" (click)="toggleDependencia(i)">
                <div class="header-left">
                    <i [class]="dep.icono"></i>
                    <h3>{{ dep.nombre }}</h3>
                </div>
                <i class="bi" [class.bi-chevron-down]="!dep.abierto" [class.bi-chevron-up]="dep.abierto"></i>
            </div>

            <div class="dependencia-content" *ngIf="dep.abierto">
                <div class="contacto-item" *ngFor="let contacto of dep.contactos">
                    <span class="cargo">{{ contacto.cargo.replace(' | ', '\n') }}</span>
                    <span class="extension">{{ contacto.extension }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Sin resultados -->
    <div class="no-results" *ngIf="searchTerm && dependenciasFiltradas.length === 0">
        <i class="bi bi-search"></i>
        <p>No se encontraron resultados para "{{ searchTerm }}"</p>
        <button (click)="limpiarBusqueda()" class="btn-limpiar">Limpiar búsqueda</button>
    </div>
</div>
</div>
<div class="directorio-container" *ngIf="id=='becas2026'">
    <div class="container my-4">
        <div class="row g-3">
            <div class="col-12 col-md-6">
                <img src="https://nld.gob.mx/assets/img/becas2026/imagen1dep.jpeg" class="img-fluid rounded shadow"
                    alt="Imagen 1">
            </div>
            <div class="col-12 col-md-6">
                <img src="https://nld.gob.mx/assets/img/becas2026/imagen2dep.jpeg" class="img-fluid rounded shadow"
                    alt="Imagen 2">
            </div>
            <div class="col-12 col-md-6">
                <img src="https://nld.gob.mx/assets/img/becas2026/imagen3dep.jpeg" class="img-fluid rounded shadow"
                    alt="Imagen 3">
            </div>
            <div class="col-12 col-md-6">
                <img src="https://nld.gob.mx/assets/img/becas2026/imagen4dep.jpeg" class="img-fluid rounded shadow"
                    alt="Imagen 4">
            </div>
            <div class="col-12 col-md-6">
                <img src="https://nld.gob.mx/assets/img/becas2026/imagen5dep.jpeg" class="img-fluid rounded shadow"
                    alt="Imagen 5">
            </div>
            <div class="col-12 col-md-6">
                <img src="https://nld.gob.mx/assets/img/becas2026/imagen6dep.jpeg" class="img-fluid rounded shadow" alt="Imagen 5">
            </div>
        </div>
    </div>
    
    <div class="container">
    
        <div class="row mt-5 mb-5">
            <div class="col-12">
    
                <div class="d-flex justify-content-center my-4 rounded">
                    <a class="btn-directorio2 mx-2" href="https://becas2026.nld.gob.mx/">
                        Ingresa aquí Beca Juntos por el Talento Deportivo 2026
                    </a>
                </div>
            </div>
    
        </div>
    
    </div>

</div>
<!--
<div class="directorio-container" *ngIf="id=='apoyos2026'">
<div class="container">

    <div class="row g-3">
        <div class="col-12 col-md-6">
            <img src="https://nld.gob.mx/assets/img/docente/imagen1.jpeg" class="img-fluid rounded shadow"
                alt="Imagen 1">
        </div>
        <div class="col-12 col-md-6">
            <img src="https://nld.gob.mx/assets/img/docente/imagen2.jpeg" class="img-fluid rounded shadow"
                alt="Imagen 2">
        </div>
        <div class="col-12 col-md-6">
            <img src="https://nld.gob.mx/assets/img/docente/imagen3.jpeg" class="img-fluid rounded shadow"
                alt="Imagen 3">
        </div>
        <div class="col-12 col-md-6">
            <img src="https://nld.gob.mx/assets/img/docente/imagen4.jpeg" class="img-fluid rounded shadow"
                alt="Imagen 4">
        </div>
        <div class="col-12 col-md-6">
            <img src="https://nld.gob.mx/assets/img/docente/imagen5.jpeg" class="img-fluid rounded shadow"
                alt="Imagen 5">
        </div>
    </div>

    <div class="row mt-5 mb-5">
        <div class="col-12">

            <div class="d-flex justify-content-center my-4">
                <a class="btn-directorio2 mx-2" href="https://apoyosmaestros.nld.gob.mx/" target="_blank">
                    APOYO AL TRABAJO DOCENTE 2026
                </a>
            </div>
        </div>

    </div>
  

</div>
</div>

-->
